export default {
  trends: {
    title: "Trends",
    navigation: {
      gameSummary: "Game Summary",
    },
    tabs: {
      player: "Player",
      team: "Team",
      parlay: "Parlay",
      sgp: "SGP",
      stats: "Stats",
    },
    help: {
      title: "Trends",
      description: "Linemate uses these signals to show the strength and context behind each trend.",
      items: {
        recentForm: "Recent form success rate",
        headToHead: "Head-to-head success rate",
        homeAway: "Home and away games success rate",
        starter: "Playing as a starter success rate (Linemate+)",
        injuryImpact: "Teammate injury impact (Linemate+)",
        opponentRank: "Opponent defensive ranking (Linemate+)",
      },
    },
    empty: {
      noTrendsAvailable: "No trends available",
      clearFilters: "Clear filters",
      offseasonTitle: "Currently Offseason",
      minimumGames: "Need 3 games minimum",
    },
    analysis: {
      title: "Trend Analysis",
      viewProfile: "View Profile",
      addToMyPicks: "Add to My Picks",
      removeFromMyPicks: "Remove from My Picks",
      addParlayToMyPicks: "Add parlay to My Picks",
      removeParlay: "Remove parlay",
      addLegToMyPicks: "Add leg to My Picks",
      removeLegFromMyPicks: "Remove leg from My Picks",
      sections: {
        playerForm: "Player Form",
        playerPerformance: "Player Performance",
        teamPerformance: "Team Performance",
        teamForm: "Team Form",
        startingLineup: "Starting Lineup",
        injuries: "Injuries",
        startingPitcher: "Starting Pitcher",
        batterVsPitcher: "Batter vs Pitcher",
        opponentDefensiveRank: "Opponent Defensive Rank",
        weather: "Weather",
        lockedAdvancedTools: "Get more with Linemate+",
        parlayLegs: "Legs",
      },
      labels: {
        status: "Status",
        player: "Player",
        type: "Type",
        viewGames: "View games",
        quickCheckout: "Quick checkout",
        showAll: "Show all",
        close: "Close",
        openOnProvider: "Open on {{provider}}",
        visitProvider: "Visit {{provider}}",
        recentForm: "Recent Form",
        headToHead: "Head to Head",
        location: "Location",
        lastFive: "Last 5",
        asStarter: "As a starter",
        startingPitcher: "Starting Pitcher",
        overallRank: "Overall rank",
        positionalRank: "Positional rank",
        confirmed: "Confirmed",
        expected: "Expected",
        withoutPlayer: "Without {{player}}",
        rankVsPosition: "Rank vs {{position}}",
        impactOn: "Impact on {{target}}",
        defensiveRankAgainst: "{{team}} Defensive Rank ‧ {{betType}} Against",
        vsPitcher: "vs {{pitcher}}",
        atBatsSummary: "{{value}} {{stat}} in {{atBats}} At Bats",
        gamesSuffix: " Games",
        noSignalsFound: "No signals found for this trend",
        noStarterSignal: "There is no starter signal",
        noStartingLineupsYet: "There are no starting lineups yet",
        noInjuryReportSignal: "There is no injury report signal",
        noInjuries: "There are currently no injuries",
      },
      summaryCards: {
        recentForm: "Recent Form",
        headToHead: "Head to Head",
        homeSplit: "Home Split",
        awaySplit: "Away Split",
        recordGames: "{{record}} Games",
        recordVs: "{{record}} vs {{opponent}}",
        recordAtHome: "{{record}} at Home",
        recordAway: "{{record}} Away",
      },
      paywall: {
        title: "Unlock the full trend analysis",
        body: "See the impact of each advanced signal.",
      },
      preview: {
        injuryImpact: "Injury Report",
        opponentRank: "Opponent Defensive Rank",
        recordPlaceholder: "100% ⋅ 00 of last 00 games",
        opponentRankPlaceholder: "00th • Positive",
        weatherPlaceholder: "Cloudy",
      },
      weatherDirections: {
        inToOut: "In To Out",
        outToRight: "Out To Right",
        outToIn: "Out To In",
        inFromLeft: "In From Left",
        inFromRight: "In From Right",
        leftToRight: "Left To Right",
        outToLeft: "Out To Left",
        rightToLeft: "Right To Left",
        unknown: "Unknown",
      },
      hints: {
        addTrendToMyPicks: "Add this trend to My Picks to place your bet",
        swipeToAddTrend: "Swipe left to quickly add a trend to My Picks.",
        swipeAddLabel: "Add",
      },
      imageImport: {
        noPicksFound: "No picks found",
        noPicksBody: "We couldn't match any picks from this image.",
        analyze: "Analyze",
      },
      gamelog: {
        title: "Gamelog",
        titleWithout: "Games played without {{name}}",
        chips: {
          last10: "Last 10",
          headToHead: "Head to Head",
          homeSplits: "Home Splits",
          awaySplits: "Away Splits",
          versusPitcher: "vs. {{pitcher}}",
        },
        headers: {
          hit: "Hit",
          date: "Date",
          versus: "Versus",
          result: "Result",
          comp: "Comp",
        },
      },
    },
    stats: {
      sections: {
        records: "Records",
        headToHead: "Head to Head",
        last5Games: "Last 5 Games",
        rankings: "Rankings",
        injuries: "Injuries",
        gameDetails: "Game Details",
      },
      picker: {
        season: "Season",
        last5: "Last 5",
        headToHead: "Head to Head",
      },
      rows: {
        recentForm: "Last 5 Games",
        season: "World Cup 2026",
        overall: "Overall",
        home: "Home",
        away: "Away",
      },
      rankings: {
        for: "FOR",
        against: "AGAINST",
      },
    },
  },
};
